var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgToursIconActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.25,
    height: 20.625,
    viewBox: "0 0 16.25 20.625",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tours-icon-active",
    transform: "translate(0.625 0.625)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2175",
    "data-name": "Path 2175",
    d: "M.484,20.484v-20h15v20",
    transform: "translate(-0.484 -0.484)",
    fill: "none",
    stroke: "#d63f94",
    strokeMiterlimit: 10,
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2176",
    "data-name": "Path 2176",
    d: "M12.689,11.893h0a1.2,1.2,0,1,1,1.2-1.2,1.205,1.205,0,0,1-1.2,1.2",
    transform: "translate(-0.893 -0.893)",
    fill: "#d63f94"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToursIconActive);
export default __webpack_public_path__ + "static/media/tours-icon-active.7cf7fce59b5ee55ddfc8676409710cc2.svg";
export { ForwardRef as ReactComponent };